import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { confirmOption } from '../../services/apiService';
import useTrackEvent from '../../utils/trackEvent';
import { useTenant } from '../../context/TenantContext';
import { useFeatureFlags } from '../../context/FeatureFlagsContext';
import { ContinueButton } from '../buttons/Buttons';

const SimulationCard = ({ option, simulationId, handlePopupClick }) => {
  const { pushCustomEvent } = useTrackEvent();
  const { isMeliTenant } = useTenant();
  const { flags, isLoadingFlags } = useFeatureFlags();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const storedFormData = JSON.parse(sessionStorage.getItem('formData')) || {};
  const executiveRut = !isLoadingFlags ? flags.executiveRut : undefined;
  const sellerRut = !isLoadingFlags ? flags.sellerRut : undefined;
  const dealerRut = !isLoadingFlags ? flags.dealerRut : undefined;
  const storeCode = !isLoadingFlags ? flags.storeCode : undefined;
  const storeCodeMeli = !isLoadingFlags ? flags.storeCodeMeli : undefined;

  const handleLoQuieroClick = async () => {
    const eventData = {
      flujo: 'Crédito Automotríz',
      button_step_value: '3',
      step: '3',
      page: '/atencion-normal/simulacion',
      PageName: 'Resultado Simulacion - Atención Normal',
      button_step_name: 'lo quiero',
      version: 'v2',
    };

    pushCustomEvent('event_buttons', eventData);

    try {
      setError(null);
      setIsLoading(true);
      storedFormData.option = option;
      storedFormData.simulationId = simulationId;

      await confirmOption({
        ...storedFormData,
        storeCode: isMeliTenant ? storeCodeMeli : storeCode,
        executiveRut,
        sellerRut,
        dealerRut,
      });
      setIsLoading(false);
      navigate('/credito-automotriz-simple/solicitud-exitosa');
    } catch (error) {
      setIsLoading(false);
      setError('¡Ups! Algo salió mal. Intenta nuevamente en unos segundos.');
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2>
          {option.type === 'CF' && (
            <p>
              <strong>CRÉDITO CUOTA FIJA - </strong>
              {option.numberOfInstallments} cuotas
            </p>
          )}
          {option.type === 'CI' && (
            <>
              <strong>CRÉDITO INTELIGENTE</strong>
              <p className="text-align-left">
                {option.numberOfInstallments - 1} meses
                <strong> + 1 de CUOTÓN</strong>
              </p>
            </>
          )}
        </h2>
        <p
          className="mas-info"
          onClick={(event) => {
            event.preventDefault();
            handlePopupClick(option.type);
          }}
        >
          Más información
        </p>
      </div>

      <div className={`card-body${option.cuoton ? '-cuoton' : ''}`}>
        <div className="card-item">
          <strong style={{ color: '#1D364C' }}>Valor cuota</strong>
          <h3 className="cuota">${(+option.installmentValue).toLocaleString('es-ES')}</h3>
        </div>

        <div className="card-item">
          <p>CAE (Costo Anual Equivalente)</p>
          <p className="item-value">
            {(+option.caeRate).toLocaleString('es-ES', {
              minimumFractionDigits: 2,
            })}
            %
          </p>
        </div>

        <div className="card-item">
          <p>Costo total del crédito</p>
          <p className="item-value">
            $
            {(option.type === 'CF'
              ? +option.installmentValue * +option.numberOfInstallments
              : +option.installmentValue * +option.numberOfInstallments + +option.vfmg
            ).toLocaleString('es-ES')}
          </p>
        </div>

        <div className="card-item">
          <ContinueButton text="LO QUIERO" onClick={handleLoQuieroClick} isLoading={isLoading} />
        </div>
        {error && <div className="error-msg">{error}</div>}
      </div>
    </div>
  );
};

export default SimulationCard;
